export default {
  // general
  test_suites: 'Test Suites',
  test_suite: 'Test Suite',

  // header content
  'test_suites.description':
    'Test Suites allow you to build your own Reliability Score. Create a Test Suite from your Scenarios, then assign it to your teams to get started. Each team can adopt one Test Suite at a time. Scoring history will be stored per Test Suite. If a new Test Suite is adopted, your services’s scores will be reset and historically tied to the new suite.',
  'test_suites.learn_more': 'Learn More',

  // list
  'test_suite.list.headers.teams_using': 'Teams Using',
  'test_suites.list.empty_text': 'No Test Suites Found',
  'test_suites.list.loading_error': 'Error loading Test Suites',
  'test_suites.list.current_team_test_suite_chip': 'Current Team',
  'test_suites.list.current_team_test_suite_tooltip':
    'Your current team is using this Test Suite',

  // common form fields
  'test_suite.common_form_field.name': 'Test Suite Name',

  // new test suite
  'test_suite.new.create_success': 'Test Suite created successfully',
  'test_suite.new.create_error': 'Failed to create Test Suite',
  'test_suite.forms.create_test_suite_form.stepper_optional': 'Optional',
  'test_suite.forms.create_test_form.view_name.add_test': 'Add Tests',
  'test_suite.forms.create_test_form.view_name.edit_risks': 'Edit Risks',
  'test_suite.forms.create_test_form.view_name.add_teams': 'Add Teams',
  'test_suite.forms.create_test_form.primary_button_text': 'Create Test Suite',

  // form
  'test_suite.forms.test_suite_team_selection.header': 'Teams',
  'test_suite.forms.test_suite_team_selection.body':
    'Each team can only adopt one test suite. Changing a test suite for a team will be an immediate change that impacts all of their services. Teams can be added later.',

  // edit test suite
  'test_suite.forms.edit_test_form.tab_teams': 'teams',
  'test_suite.forms.edit_test_form.tab_tests': 'tests',
  'test_suite.forms.edit_test_form.tab_risks': 'risks',
  'test_suite.edit.page_title': 'Edit Test Suite: {{testSuiteName}}',
  'test_suite.edit.page_title_read_only': 'Test Suite: {{testSuiteName}}',
  'test_suite.edit.update_success': 'Test Suite updated successfully',
  'test_suite.edit.update_error': 'Failed to update Test Suite',

  // TestSuiteScenarioInfo
  'test_suites.test_suite_scenario_info.owner_label': 'Owning Team',
  'test_suites.test_suite_scenario_info.scenario_id_label': 'Scenario ID',

  // team table
  'test_suites.team_selection.table.empty': 'No Teams Selected',
  'test_suites.team_selection.table.header.name': 'Team Name',
  'test_suites.team_selection.table.header.since': 'Since',

  // add / edit drawer
  'test_suites.details.add_edit_drawer.test_preview.chip.service.label':
    'Service',
  'test_suites.details.add_edit_drawer.test_preview.chip.service.tooltip':
    'This test step targets your service',
  'test_suites.details.add_edit_drawer.test_preview.chip.dependency.label':
    'Dependency',
  'test_suites.details.add_edit_drawer.test_preview.chip.dependency.tooltip':
    'This test step targets each dependency of your service',
  'test_suites.details.add_edit_drawer.test_preview.chip.random_zone.label':
    'Random Zone',
  'test_suites.details.add_edit_drawer.test_preview.chip.random_zone.tooltip':
    "This test step targets a subset of your service's network traffic by impacting traffic to a randomly selected availability zone",
  'test_suites.details.add_edit_drawer.test_preview.chip.random_dns.label':
    'Random DNS',
  'test_suites.details.add_edit_drawer.test_preview.chip.random_dns.tooltip':
    "This test step targets a random DNS server from your service's network traffic, making it unreachable from the hosts.",

  // delete modal
  'test_suites.list.delete.success': 'Successfully deleted Test Suite {{name}}',
  'test_suites.list.delete_modal.text':
    'Are you sure you want to delete this Test Suite?',
  'test_suites.list.delete_modal.title': 'Delete Test Suite?',

  // save dialog
  'test-suites.save_dialog.title': 'Save Changes?',
  'test-suites.save_dialog.content':
    'Saving will be an immediate team-wide change. Any running tests will be halted for those teams. Team scores will be reset and historically tied to the new Test Suite. Adopting the previous suite will restore previous scores.',

  // errors
  'test_suites.list.delete.error':
    'There was a problem while removing the Test Suite. Please try again.',
  'test_suites.errors.loading_error': 'Error loading Test Suites',
  'test_suites.errors.page_loading_error':
    'We encountered an error on this page. Please try again later.'
}
